<template>
  <div class="subbranch" v-loading="loading">
    <div class="mb15">
      <el-select :disabled="readonly" class="filter" v-model="form.province_id" filterable clearable allow-create placeholder="請選擇省份">
        <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="mb15">
      <el-select :disabled="readonly" class="filter" v-model="form.city_id" filterable clearable allow-create placeholder="請選擇城市">
        <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div v-show="!readonly">
      <el-select :disabled="readonly" class="filter" @change="setbranchname" v-model="form.branch_id" clearable filterable allow-create remote reserve-keyword placeholder="請輸入支行名稱進行搜尋" :remote-method="remoteMethod" :loading="loading">
        <el-option v-for="item in bankBranchList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => { }
    },
    reset: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      loading: true,
      provinceList: [],
      cityList: [],
      bankBranchList: [],
    }
  },
  mounted () {
    this.elSelectFocus();
  },
  methods: {
    // 初始化數據
    init () {
      this.getProvinceList();
    },
    // 獲取省份列表
    getProvinceList () {
      this.loading = true;
      this.post('/api/bank/province', { page: 1, size: 300, condition: '' })
        .then(response => {
          this.loading = false;
          let provinceList = response;
          this.provinceList = provinceList.map(item => {
            return { value: `${item.code}`, label: `${item.name}` };
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    setbranchname () {
      let branch_id = this.form.branch_id;
      let bankBranchList = this.bankBranchList;
      let tempname = '';
      bankBranchList.some(item => {
        if (item.value == branch_id) {
          tempname = item.label;
        }
      })
      this.form.branch_name = tempname;
    },
    getBranchList (query = '') {
      this.loading = true;
      let bank_id = 0;
      let city_id = '';
      let province_id = '';
      let branch_id = '';
      if (!this.reset) {
        bank_id = this.form.cnbank_id;
        city_id = this.form.city_id;
        province_id = this.form.province_id;
        branch_id = this.form.branch_id;
      } else {
        bank_id = this.form.bank_id;
        city_id = '';
        province_id = '';
      }
      let requestData = {
        name: query,
        bank_id: bank_id,
        city_id: city_id,
        province_id: province_id,
        branch_id: branch_id,
      };
      this.post('/api/bank/bank_branch', requestData)
        .then(response => {
          let bankBranchList = response;
          this.bankBranchList = bankBranchList.map(item => {
            return { value: `${item.id}`, label: `${item.name}` };
          });
          this.loading = false;
        }).catch(error => {
          console.log(error);
        });

    },
    getcity () {
      let val = this.form.province_id;
      this.post('/api/bank/city', { code: val })
        .then(response => {
          let cityList = response;
          this.cityList = cityList.map(item => {
            return { value: `${item.code}`, label: `${item.name}` };
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    remoteMethod (query) {
      if (query !== '') {
        this.getBranchList(query);
      } else {
        this.options = [];
      }
    }
  },
  created () {
    if (this.reset) {
      this.form.province_id = '';
      this.form.city_id = '';
      this.form.branch_id = '';
      this.form.branch_name = '';
    } else {
      this.getcity();
      this.getBranchList();
    }
    this.init();
  },
  watch: {
    'form.province_id' (val) {
      if (this.reset) {
        this.bankBranchList = [];
        this.options = [];
        this.form.city_id = '';
        this.form.branch_id = '';
      }

      this.getcity();

    },
    'form.city_id' (val) {
      if (this.reset) {
        this.bankBranchList = [];
        this.options = [];
        this.form.branch_id = '';
      }
      if (val != '') {
        this.getBranchList();
      }
    },
    'form.branch_id' (val) {
      this.setbranchname();
    },
    'form.cnbank_id' (val) {
      this.bankBranchList = [];
      this.form.branch_id = '';
      this.getBranchList();
    }
  }
}
</script>

<style scoped>
.el-select > .el-input {
  display: inline-block !important;
}
.mb15 {
  margin-bottom: 15px;
}
</style>